export default __webpack_public_path__ + "static/media/CV7.0c1229b3.png";